import { BadgeActionCard, LoadingActionCard } from '@account/components';
import { EarnedBadge } from '@account/types';
import { PaginationReturn } from '@common/types/service';
import { CenteredEmptyState } from '@components/display/emptyStates';
import { Pagination } from '@components/utility/pagination';
import { Stack } from '@mui/material';
import { useGetMyEarnedBadgesQuery } from '@services/accounts';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

export const EarnedBadgesMobile = () => {
    const [page, setPage] = useState(1);

    const { data: earnedBadgesMobileData, isFetching: isEarnedBadgesMobileFetching } = useGetMyEarnedBadgesQuery({
        page,
        page_size: 3,
    });
    const earnedBadgesMobile = earnedBadgesMobileData as PaginationReturn<EarnedBadge>;

    // Prefetch adjacent pages
    useGetMyEarnedBadgesQuery(
        {
            page: page - 1,
            page_size: 3,
        },
        {
            skip: page === 1,
        }
    );

    useGetMyEarnedBadgesQuery({
        page: page + 1,
        page_size: 3,
    });
    //#endregion

    return (
        <>
            <Stack direction="column" gap="24px" mb="24px">
                {isEarnedBadgesMobileFetching ? (
                    Array.from({ length: 3 }).map((_, index) => <LoadingActionCard key={`skeleton-${index}`} />)
                ) : earnedBadgesMobile?.count > 0 ? (
                    earnedBadgesMobile?.results.map((badge) => <BadgeActionCard key={badge.id} badge={badge} />)
                ) : (
                    <CenteredEmptyState
                        message={
                            <FormattedMessage
                                id="account.events.noEarnedBadges"
                                defaultMessage="You haven't earned any badges yet."
                            />
                        }
                    />
                )}
            </Stack>
            {earnedBadgesMobile?.count > 0 && (
                <Pagination
                    count={Math.ceil(earnedBadgesMobile.count / 3)}
                    onChange={(_e, newPage) => setPage(newPage)}
                />
            )}
        </>
    );
};
